import {clientsClaim as workbox_core_clientsClaim} from '/codebuild/output/src297027973/src/TPR-NELIA/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/codebuild/output/src297027973/src/TPR-NELIA/node_modules/workbox-precaching/precacheAndRoute.mjs';
import {cleanupOutdatedCaches as workbox_precaching_cleanupOutdatedCaches} from '/codebuild/output/src297027973/src/TPR-NELIA/node_modules/workbox-precaching/cleanupOutdatedCaches.mjs';
import {registerRoute as workbox_routing_registerRoute} from '/codebuild/output/src297027973/src/TPR-NELIA/node_modules/workbox-routing/registerRoute.mjs';
import {NavigationRoute as workbox_routing_NavigationRoute} from '/codebuild/output/src297027973/src/TPR-NELIA/node_modules/workbox-routing/NavigationRoute.mjs';
import {createHandlerBoundToURL as workbox_precaching_createHandlerBoundToURL} from '/codebuild/output/src297027973/src/TPR-NELIA/node_modules/workbox-precaching/createHandlerBoundToURL.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "android-chrome-192x192.png",
    "revision": "0847513e38e0fa997d947d3e61450acd"
  },
  {
    "url": "android-chrome-512x512.png",
    "revision": "9ce970cc1a5d7f96d8ea13cdd917aa16"
  },
  {
    "url": "apple-touch-icon.png",
    "revision": "5b0bca38301aefbaf86f02e42275e378"
  },
  {
    "url": "assets/auto-BM9z43yv.js",
    "revision": null
  },
  {
    "url": "assets/favicon-BUJ9MghA.ico",
    "revision": null
  },
  {
    "url": "assets/favicon-DXA37RlF.ico",
    "revision": null
  },
  {
    "url": "assets/footer-image-s6AF75oR.png",
    "revision": null
  },
  {
    "url": "assets/index-CZ6KLwE-.css",
    "revision": null
  },
  {
    "url": "assets/index-CZW02FnH.js",
    "revision": null
  },
  {
    "url": "assets/logo-1SIoMu6h.png",
    "revision": null
  },
  {
    "url": "assets/logo-CdIo6mIi.png",
    "revision": null
  },
  {
    "url": "assets/logo-CSfy7YFN.png",
    "revision": null
  },
  {
    "url": "assets/logo-CslSVsES.png",
    "revision": null
  },
  {
    "url": "assets/logo-Dj6s7LKO.png",
    "revision": null
  },
  {
    "url": "assets/logo-DOQRZliR.png",
    "revision": null
  },
  {
    "url": "assets/logo-DriS3XEv.png",
    "revision": null
  },
  {
    "url": "assets/logo-DVM18Z6P.png",
    "revision": null
  },
  {
    "url": "assets/logo-issAKjtU.png",
    "revision": null
  },
  {
    "url": "assets/logo-o8GBXieh.png",
    "revision": null
  },
  {
    "url": "assets/primeicons-Dr5RGzOO.svg",
    "revision": null
  },
  {
    "url": "assets/white-logo-aw5G-bRa.png",
    "revision": null
  },
  {
    "url": "assets/white-logo-BhkKC4l8.png",
    "revision": null
  },
  {
    "url": "assets/white-logo-CaVzOY1I.png",
    "revision": null
  },
  {
    "url": "assets/white-logo-D3eU_aBI.png",
    "revision": null
  },
  {
    "url": "assets/white-logo-ItQne2jD.png",
    "revision": null
  },
  {
    "url": "assets/white-logo-T6ZdwAtv.png",
    "revision": null
  },
  {
    "url": "assets/white-logo-uFY6lqq0.png",
    "revision": null
  },
  {
    "url": "assets/white-logo-xPsflh7U.png",
    "revision": null
  },
  {
    "url": "assets/workbox-window.prod.es5-B9K5rw8f.js",
    "revision": null
  },
  {
    "url": "favicon-16x16.png",
    "revision": "0f92e15bf3ac5b1725c62b61a67ed898"
  },
  {
    "url": "favicon-32x32.png",
    "revision": "4cda83c9f06d92f65f4cb5cbdd413852"
  },
  {
    "url": "index.html",
    "revision": "0f0559a42020b7ef1bcf6c3987cefd54"
  },
  {
    "url": "logo.png",
    "revision": "4606b54d5f4b5bc6288a19da7e7f262a"
  },
  {
    "url": "android-chrome-192x192.png",
    "revision": "0847513e38e0fa997d947d3e61450acd"
  },
  {
    "url": "android-chrome-512x512.png",
    "revision": "9ce970cc1a5d7f96d8ea13cdd917aa16"
  },
  {
    "url": "apple-touch-icon.png",
    "revision": "5b0bca38301aefbaf86f02e42275e378"
  },
  {
    "url": "manifest.webmanifest",
    "revision": "45f93a5695fded38f003ed38f19128ca"
  }
], {});
workbox_precaching_cleanupOutdatedCaches();
workbox_routing_registerRoute(new workbox_routing_NavigationRoute(workbox_precaching_createHandlerBoundToURL("index.html")));






